import { render, staticRenderFns } from "./Decisao.vue?vue&type=template&id=8de12bbe&scoped=true"
import script from "./Decisao.vue?vue&type=script&lang=js"
export * from "./Decisao.vue?vue&type=script&lang=js"
import style0 from "./Decisao.vue?vue&type=style&index=0&id=8de12bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de12bbe",
  null
  
)

export default component.exports